export const defaultStyleId = 'typestyle-target'
